import Login from "pages/Login";
import { Route, Routes } from "react-router-dom";

const publicOnly = [
    { path: "/l", element: <Login/> }
];

export default publicOnly;